module.exports = __webpack_public_path__ + "img/logo-light.7f0a79f0.png";